module.exports = "/participant_active@2x-5592e6b73e3fb1dc280264db3c7cff81.png";